import {combineReducers} from 'redux';
import {authRiderReducer} from './authReducer'
import {customerSignInReducer } from './customerSignInReducer';
const reducer = combineReducers({
   customerSignInReducer,authRiderReducer 
    });
    
    export default reducer;
